import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Body, Link } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export const LearnMoreText = () => {
  const href = 'https://knowledge.hubspot.com/records/enrich-your-contact-and-company-data';
  return /*#__PURE__*/_jsx(Body, {
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "enrichmentProperties.panel.error.learnMore",
      options: {
        kbLink: /*#__PURE__*/_jsx(Link, {
          display: "block",
          href: href,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "enrichmentProperties.panel.error.kbArticle"
          })
        })
      }
    })
  });
};